import { useEffect, useState, useCallback } from "react";
import { useDeudoresCBO } from "../../Services/Deudores";

export const useGetDeudores = () => {
  const { getDeudores } = useDeudoresCBO();

  const [deudores, setDeudores] = useState([]);
  const [errorDeudores, setErrorDeudores] = useState(null);
  const [loadingDeudores, setLoadingDeudores] = useState(true);

  const fetchDeudores = useCallback(async () => {
    setLoadingDeudores(true);
    try {
      const data = await getDeudores();
      setDeudores(data);
    } catch (error) {
      setErrorDeudores(error?.message || "Error al obtener deudores");
    } finally {
      setLoadingDeudores(false);
    }
  }, [getDeudores]);

  useEffect(() => {
    fetchDeudores();
  }, [fetchDeudores]); 

  return {
    deudores,
    errorDeudores,
    loadingDeudores,
    refetchDeudores: fetchDeudores,
  };
};

export const useGetDeudoresReporteFinancieroActual = () => {
  const { getReporteUltimoMesDeudores } = useDeudoresCBO();

  const [deudoresReporte, setDeudoresReporte] = useState(null);
  const [errorDeudoresReporte, setErrorDeudoresReporte] = useState(null);
  const [loadingDeudoresReporte, setLoadingDeudoresReporte] = useState(true);

  const fetchReporte = useCallback(async () => {
    setLoadingDeudoresReporte(true);
    try {
      const data = await getReporteUltimoMesDeudores();
      setDeudoresReporte(data);
      setErrorDeudoresReporte(null);
    } catch (error) {
      setErrorDeudoresReporte(error?.message || "Error al obtener reporte");
    } finally {
      setLoadingDeudoresReporte(false);
    }
  }, [getReporteUltimoMesDeudores]);

  useEffect(() => {
    fetchReporte();
  }, [fetchReporte]);

  return {
    deudoresReporte,
    errorDeudoresReporte,
    loadingDeudoresReporte,
  };
};
export const useGetDeudoresAnteriores = (mes, anio) => {
  const { getReporteAnteriorDeudores } = useDeudoresCBO();

  const [deudoresReporteanterior, setDeudoresReporteAnterior] = useState(null);
  const [errorDeudoresReporteAnterior, setErrorDeudoresReporteAnterior] = useState(null);
  const [loadingDeudoresReporteAnterior, setLoadingDeudoresReporteAnterior] = useState(false);

  const fetchReporteAnterior = useCallback(async () => {
    if (!mes || !anio) return;

    setLoadingDeudoresReporteAnterior(true);
    try {
      const data = await getReporteAnteriorDeudores(mes, anio);
      setDeudoresReporteAnterior(data);
      setErrorDeudoresReporteAnterior(null);
    } catch (error) {
      setErrorDeudoresReporteAnterior(error);
    } finally {
      setLoadingDeudoresReporteAnterior(false);
    }
  }, [mes, anio, getReporteAnteriorDeudores]);

  useEffect(() => {
    fetchReporteAnterior();
  }, [fetchReporteAnterior]);

  return {
    deudoresReporteanterior,
    errorDeudoresReporteAnterior,
    loadingDeudoresReporteAnterior,
  };
};


export const useGetReporteAnual = () => {
  const { getReporteAnual } = useDeudoresCBO();

  const [reporteAnual, setReporteAnual] = useState(null);
  const [anualSeleccionado, setAnualSeleccionado] = useState(null);

  const [errorReporteAnual, setErrorReporteAnual] = useState(null);
  const [loadingReporteAnual, setLoadingReporteAnual] = useState(true);

  const fetchReporteAnual = useCallback(
    async (anio = null) => {
      setLoadingReporteAnual(true);
      setErrorReporteAnual(null);

      try {
        const data = await getReporteAnual(anio);

        setReporteAnual(data);

        // Si no se seleccionó un año,
        // usamos el último año que devuelve el backend
        if (!anio && data?.anio_seleccionado) {
          setAnualSeleccionado(data.anio_seleccionado);
        }

        return data;

      } catch (error) {
        setErrorReporteAnual(
          error?.message || "Error al obtener reporte anual"
        );
      } finally {
        setLoadingReporteAnual(false);
      }
    },
    [getReporteAnual]
  );

  // Carga inicial
  useEffect(() => {
    fetchReporteAnual();
  }, [fetchReporteAnual]);

  // Cambiar año
  const cambiarAnio = useCallback(
    async (anio) => {
      setAnualSeleccionado(anio);

      await fetchReporteAnual(anio);
    },
    [fetchReporteAnual]
  );

  return {
    reporteAnual,
    anualSeleccionado, 
    setAnualSeleccionado,

    errorReporteAnual,
    loadingReporteAnual,

    cambiarAnio,
    refetchReporteAnual: fetchReporteAnual,
  };
};

